import { useMemo } from 'react';
import chunk from 'lodash/chunk';
import isEmpty from 'lodash/isEmpty';

const initialFields = ['first_name', 'last_name', 'date_of_birth'];

const useSortFields = (missingFields = [], requiredFields = initialFields) => {
  const fields = useMemo(() => {
    if (missingFields && !isEmpty(missingFields)) {
      const sortedFields = missingFields.sort((nameA, nameB) =>
        nameA.includes('day')
          ? 1
          : nameB.includes('birth') || nameB.includes('date')
          ? -1
          : 0
      );
      const filteredArray = sortedFields.filter(item => item !== 'signature');

      const allFields = [...requiredFields, ...filteredArray];
      // eslint-disable-next-line
      const uniqFields = [...new Set(allFields)];

      return uniqFields;
    }
    // eslint-disable-next-line
  }, [missingFields.length, requiredFields.length]);

  return { fields, chunkedFields: chunk(fields, 2) || [] };
};

export default useSortFields;
